import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Title from './Title';


export default function PaperWidget( { title, children, gridProps, paperProps } ) {
  return (

    <Grid item {...gridProps}>
      <Paper {...paperProps}>
        <Title>{title}</Title>
        {children}
      </Paper>
    </Grid>

  );
};